<template>
  <v-dialog v-model="dialog" scrollable persistent fullscreen>
    <v-card class="primary--text">
      <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
        {{ $t(titulo) | capitalize }}
        <v-spacer></v-spacer>
        <v-btn icon right @click="cerrar" color="error">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col class="pa-0 pt-4">
              <p>* {{ $t('tooltipForm') }}</p>
            </v-col>

          </v-row>

          <v-row>
            <v-col class="primary--text font-weight-bold pa-0 pt-4">{{ $t("descrip_empresa") }}</v-col>
          </v-row>

          <v-row>
            <v-col class="pa-0">
              <v-text-field v-model="form.marca" :label="$t('label_marca')" hide-details/>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pa-0">
              <v-text-field v-model="form.coleccion" :label="$t('label_colec')" hide-details/>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pa-0">
              <v-text-field v-model="form.enlace" :label="$t('label_enlace')" hide-details/>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="primary--text font-weight-bold px-0 pt-6">{{ $t("descrip_material") }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="2" class="px-0">
              {{ $t("material") | capitalize }}:
            </v-col>
            <v-col cols="5">
              <v-select :disabled="ceramicos.length < 1 || form.noCeramico != null"
                        :label="$t('ceramico') | capitalize" v-model="form.ceramico" :items="ceramicos"
                        item-value="codigo" item-text="nombre" @change="seleccionarMaterial" return-object hide-details
                        class="pt-0"/>
            </v-col>
            <v-col cols="5">
              <v-select :disabled="noCeramicos.length < 1 || form.ceramico != null"
                        :label="$t('no_ceramico') | capitalize" v-model="form.noCeramico" :items="noCeramicos"
                        item-value="codigo" item-text="nombre" @change="seleccionarMaterial" return-object hide-details
                        class="pt-0"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="2" class="px-0">{{ $t("uso") | capitalize }}:</v-col>
            <v-col cols="10">
              <v-row no-gutters>
                <v-col class="pa-0" cols="4" v-for="val in usos" :key="val.codigo">
                  <v-checkbox v-model="form.usos" :label="val.nombre" :value="val.codigo" hide-details
                              class="mt-0 pt-0" @change="cargarPrestacionales"/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row v-if="errorMateriales">
            <v-col cols="12">
              <v-alert type="error" text dense>{{ errorMateriales }}</v-alert>
            </v-col>
          </v-row>

          <v-row class="pb-0">
            <v-col class="primary--text font-weight-bold px-0 pt-4">{{ $t("descrip_producto") }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <v-text-field v-model="form.ancho" :label="$t('label_ancho')" type="number" hide-details/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="form.largo" :label="$t('label_largo')" type="number" hide-details/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="form.espesor" :label="$t('label_espesor')" type="number" hide-details/>
            </v-col>
          </v-row>

          <v-row v-if="form.ceramico">
            <v-col cols="2" class="px-0">{{ $t("absorcion_agua") | capitalize }}:</v-col>
            <v-col cols="10" class="px-0">
              <v-row no-gutters>
                <v-col class="pa-0" cols="4" v-for="val in absorcionAgua" :key="val.codigo">
                  <v-checkbox v-model="form.absorcionAgua" :label="val.nombre" :value="val.codigo" hide-details
                              class="mt-0 pt-0"/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="primary--text font-weight-bold px-0 pt-4">{{ $t("descrip_personalizacion") }}</v-col>
          </v-row>

          <v-row>
            <v-col class="pa-0 pb-1">
              <v-text-field v-model="form.precio" type="number" :label="$t('label_precio')" hide-details/>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="px-0 mt-4">
              <v-card class="mx-auto" :flat="!addDap" :outlined="addDap">
                <v-card-title class="pa-0" :class="{'primary': addDap}">
                  <v-switch v-model="addDap" :color="addDap ? 'white' : 'primary'" class="mx-2"/>
                  <span class="body-1" :class="{'white--text': addDap, 'primary--text': !addDap}">
                    {{ $t('dap') }}
                  </span>
                </v-card-title>
                <v-card-text v-show="addDap" class="pt-2">
                  <div class="primary--text">
                    {{ $t('dap_descrip_eval') }}.
                    {{ $t('pers_amb_pers_descrip') }}
                  </div>
                  <impactos-componente :mostrar-titulo="false" :nombre="$t('dap')" :impactos="impactos"
                                       :impactos-sol-cons="form.ambientales"/>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="px-0 pt-0">
              <v-card class="mx-auto" :flat="!addPres" :outlined="addPres">
                <v-card-title class="pa-0" :class="{'primary': addPres}">
                  <v-switch v-model="addPres" :color="addPres ? 'white' : 'primary'" class="mx-2"/>
                  <span class="body-1" :class="{'white--text': addPres, 'primary--text': !addPres}">
                    {{ $t('dpres')  | capitalize }}
                  </span>
                </v-card-title>
                <v-card-text v-show="addPres" class="pa-0">
                  <v-alert type="warning" v-show="!prestacionales.valores && !prestacionales.cargando"
                           class="my-4 mx-2">
                    {{ $t("alert_prestacionales") }}
                  </v-alert>
                  <v-alert color="tertiary" v-show="prestacionales.cargando" class="my-4 mx-2">
                    <v-progress-circular indeterminate class="mr-2 v-progress-circular--visible" color="primary"
                                         size="25" width="3"/>
                    {{ $t("cargando_prestacionales") }}
                  </v-alert>
                  <v-row no-gutters>
                    <v-col cols="12" class="pa-4">
                      <span class="primary--text">
                        {{ $t('pers_cat_tecni_descrip')  | capitalize }}
                      </span>
                    </v-col>
                    <v-col cols="12" class="pa-0">
                      <v-tabs v-model="prestacionales.tabSeleccionada"
                              v-if="!prestacionales.cargando && prestacionales.valores">
                        <v-tab v-for="(pres,i) in Object.keys(prestacionales.valores)" :key="i"
                               @click="prestacionales.seleccionado = prestacionales.valores[pres]">
                          {{ prestacionales.valores[pres].material }}
                        </v-tab>
                      </v-tabs>
                    </v-col>
                  </v-row>
                  <v-row v-if="prestacionales.seleccionado"
                         class="d-flex flex-nowrap overflow-visible overflow-x-auto mt-1" no-gutters>
                    <v-col cols="3" v-for="(sol,idxSol) in prestacionales.seleccionado.soluciones" v-show="sol.visible"
                           :key="idxSol">
                      <v-row no-gutters>
                        <v-col class="primary white--text pa-2">{{ sol.nombre }}</v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="12" v-for="(prestacional,idxPres) in sol.indicadores" :key="idxPres" class="pa-2">
                          <indicador-prestacional :indicador="prestacional"
                                                  :prestacion="prestacionales.valores[prestacionales.seleccionado['codigo']].soluciones[idxSol].modelo"
                          />
                        </v-col>
                        <v-col cols="12" class="pa-1">
                          <v-btn color="primary" @click="prestacionales.mostrarResto=!prestacionales.mostrarResto">
                            {{ $t("ver_rest_indi") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row no-gutters v-show="prestacionales.mostrarResto">
                        <v-col cols="12" v-for="(prestacional,idxPres) in sol.resto" :key="`${idxPres}-idx`"
                               class="pa-2">
                          <indicador-prestacional :indicador="prestacional"
                                                  :prestacion="prestacionales.valores[prestacionales.seleccionado['codigo']].soluciones[idxSol].modelo"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="primary--text font-weight-bold px-0 pt-4">{{ $t("descrip_imagen") }}</v-col>
          </v-row>

          <v-row>
            <v-col class="pa-0">{{ $t("descrip_imagen_larga") }}</v-col>
          </v-row>

          <v-row>
            <v-file-input v-model="imagen" class="pa-0"/>
          </v-row>

        </v-container>
      </v-card-text>
      <v-card-actions class="pb-3 px-1">
        <v-spacer/>
        <v-btn color="error" :disabled="guardando" text @click="cerrar()">
          {{ $t('cerrar') | capitalize }}
        </v-btn>
        <v-tooltip left :disabled="esValido()">
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" class="d-inline-block">
              <v-btn
                  color="primary"
                  :loading="guardando"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!esValido()"
                  @click="guardar()"
              >
                {{ $t('guardar') | capitalize }}
              </v-btn>
            </div>
          </template>
          <span>{{ $t('tooltipForm') }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import ImpactosComponente
  from "../../../proyecto-detalles/Componentes/SolucionConstructiva/DeclaracionAmbiental/Componentes/ImpactosComponente";
import IndicadorPrestacional from "./Componentes/IndicadorPrestacional";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";

export default {
  name: "BtnAddMaterialPers",
  props: {
    mostrar: {type: Boolean, required: true},
    disabled: {type: Boolean, default: false},
    materialEdit: {type: Object, default: null, required: false}
  },
  model: {
    prop: 'mostrar',
    event: 'change'
  },
  components: {
    ImpactosComponente,
    IndicadorPrestacional
  },
  data: () => ({
    dialog: false,
    form: {
      marca: null,
      coleccion: null,
      enlace: null,
      ceramico: null,
      noCeramico: null,
      usos: [],
      ancho: null,
      largo: null,
      espesor: null,
      absorcionAgua: null,
      precio: null,
      ambientales: {},
      imagenB64: null
    },
    solCons: [],
    materialesLoad: false,
    materiales: [],
    impactos: [],
    prestacionales: {
      valores: null,
      tabSeleccionada: 0,
      seleccionado: null,
      mostrarResto: false
    },
    guardando: false,
    addDap: false,
    addPres: false,
    ceramicos: [],
    noCeramicos: [],
    usos: [],
    absorcionAgua: [],
    imagen: null
  }),
  watch: {
    dialog: function (val) {
      if (val) this.init();
    },
    mostrar(val) {
      this.dialog = val;
    },
    imagen(val) {
      if (val) {
        let fileReader = new FileReader();
        fileReader.addEventListener("load", (e) => {
          this.form.imagenB64 = e.target.result;
        });
        fileReader.readAsDataURL(val);
      } else this.form.imagenB64 = null;
    }
  },
  computed: {
    esEdit() {
      return this.materialEdit != null;
    },
    titulo() {
      if (this.materialEdit == null) return "dialog_titulo";
      return "dialog_titulo_edit";
    },
    errorMateriales() {
      if (!this.form.usos) return null;

      let materiales = [];
      if (this.form.ceramico) materiales = materiales.concat([this.form.ceramico]);
      if (this.form.noCeramico) materiales = materiales.concat([this.form.noCeramico]);

      let usosSeleccionados = [];
      this.usos.forEach((uso) => {
        if (this.form.usos.includes(uso.codigo)) usosSeleccionados.push(uso);
      });

      let error = null;
      usosSeleccionados.forEach((uso) => {
        uso.referencias.forEach((ref) => {
          materiales.forEach((mat) => {
            let fail = false;
            switch (ref.codigo) {
              case "obra_nueva_horizontal":
                if (!mat.refHorizontal) fail = true;
                break;
              case "obra_nueva_vertical":
                if (!mat.refVertical) fail = true;
                break;
              case "obra_nueva_urbano":
                if (!mat.refUrbano) fail = true;
                break;
              case  "obra_nueva_fachada":
                if (!mat.refFachada) fail = true;
                break;
              case "horizontal_rehabilitation":
                if (!mat.refRehHorizontal) fail = true;
                break;
              case "vertical_rehabilitation":
                if (!mat.refRehVertical) fail = true;
                break;
              case "facade_rehabilitation":
                if (!mat.refRehFachada) fail = true;
                break;
              case "obra_nueva_exterior":
                if (!mat.refExterior) fail = true;
                break;
              case "rehabilitacion_exterior":
                if (!mat.refRehExterior) fail = true;
                break;
            }

            if (fail) error = `El material ${mat.nombre} no es compatible con el uso ${uso.nombre}`;
          });
        });
      });

      return error;
    }
  },
  methods: {
    init() {
      this.reset();

      this.cargarCeramicos();
      this.cargarNoCeramicos();
      this.cargarUsos();
      this.cargarAbsorcionAgua();
      this.cargarImpactos();

      if (this.materialEdit != null) {
        this.form.marca = this.materialEdit.marca;
        this.form.coleccion = this.materialEdit.coleccion;
        this.form.enlace = this.materialEdit.enlace;
        this.form.ceramico = this.materialEdit.ceramicos && this.materialEdit.ceramicos.length > 0
            ? this.materialEdit.ceramicos[0] : null;
        this.form.noCeramico = this.materialEdit.noCeramicos && this.materialEdit.noCeramicos.length > 0
            ? this.materialEdit.noCeramicos[0] : null;
        this.form.espesor = this.materialEdit.espesor;
        if (this.materialEdit.absorcionAgua) this.form.absorcionAgua = this.materialEdit.absorcionAgua.codigo;
        this.form.precio = this.materialEdit.costeUnitarioAcabado;

        let anchoLargo = this.materialEdit.formato.split('x')
        this.form.ancho = anchoLargo[0]
        this.form.largo = anchoLargo[1]

        for (let i = 0; i < this.materialEdit.usos.length; i++) {
          this.form.usos.push(this.materialEdit.usos[i].codigo)
        }

        if (this.materialEdit.declaracionAmbientalDermis != null) {
          this.form.ambientales = this.materialEdit.declaracionAmbientalDermis;
          this.addDap = true;
        }

        if (this.materialEdit.prestaciones != null && this.materialEdit.prestaciones.length > 0) {
          this.addPres = true;
        }

        this.cargarPrestacionales();
      }
    },
    seleccionarMaterial() {
      this.cargarPrestacionales();
    },
    cargarImpactos() {
      this.impactos = [];

      HttpHelper.get("impactos").then(data => {
        this.impactos = data;
      });
    },
    cargarPrestacionales() {
      this.prestacionales.cargando = true;
      this.prestacionales.valores = null;
      this.prestacionales.seleccionado = null;
      if (this.errorMateriales || (!this.form.ceramico && !this.form.noCeramico)) {
        this.prestacionales.cargando = false;
        return;
      }
      const materiales = this.form.ceramico ? [this.form.ceramico] : [this.form.noCeramico];

      let promesas = [];
      materiales.forEach((material) => {
        [
          {nombre: "Pavimiento interior", codigo: "refHorizontal", uso: "pav_interior", visible: true, copiarDe: null},
          {nombre: "Revestimiento interior", codigo: "refVertical", uso: "rev_interior", visible: true, copiarDe: null},
          {nombre: "Fachada", codigo: "refFachada", uso: "fachada", visible: true, copiarDe: null},
          {nombre: "Pavimiento urbano", codigo: "refUrbano", uso: "pav_urbano", visible: true, copiarDe: null},
          {
            nombre: "Rehabilitación pavimiento interior",
            codigo: "refRehHorizontal",
            uso: "pav_interior",
            visible: false, copiarDe: "refHorizontal"
          },
          {
            nombre: "Rehabilitación revestimiento interior",
            codigo: "refRehVertical",
            uso: "rev_interior",
            visible: false, copiarDe: "refVertical"
          },
          {
            nombre: "Rehabilitación Fachada",
            codigo: "refRehFachada",
            uso: "fachada",
            visible: false,
            copiarDe: "refFachada"
          }
        ]
            .forEach((sol) => {
              const codMaterial = material[sol.codigo];

              if (codMaterial && this.form.usos.filter((uso) => uso === sol.uso).length > 0) {
                const prom = HttpHelper.get(`material-personalizado/indicadores-prestacionales/${codMaterial}`);
                promesas.push(prom);
                prom.then(data => {
                  let modelo = {};
                  if (this.esEdit) {
                    const filtrados = this.materialEdit.prestaciones.filter((a) => a.codigoMaterial === codMaterial);
                    if (filtrados.length > 0) {
                      modelo = filtrados[0].prestacionDermis.parametros;
                    }
                  }
                  const indicadoresSolucion = {
                    codigoMaterial: codMaterial,
                    nombre: sol.nombre,
                    indicadores: data.defecto,
                    resto: data.resto,
                    modelo: modelo,
                    codigoSol: sol.codigo,
                    visible: sol.visible,
                    copiarDe: sol.copiarDe
                  };
                  if (!this.prestacionales.valores) this.prestacionales.valores = {};
                  if (Object.keys(this.prestacionales.valores).includes(material.codigo))
                    this.prestacionales.valores[material.codigo].soluciones.push(indicadoresSolucion);
                  else
                    this.prestacionales.valores[material.codigo] = {
                      codigo: material.codigo,
                      material: material.nombre,
                      soluciones: [indicadoresSolucion]
                    };
                });
              }
            });
      });

      if (promesas.length > 0)
        Promise.all(promesas).then(() => {
          if (this.prestacionales.valores) {
            const keys = Object.keys(this.prestacionales.valores);

            if (keys.length > 0) {
              keys.forEach((key) => {
                this.prestacionales.valores[key].soluciones =
                    this.prestacionales.valores[key].soluciones.sort((a, b) => {
                      return a.nombre > b.nombre ? 1 : (a.nombre < b.nombre ? -1 : 0);
                    });
              });

              this.prestacionales.seleccionado = this.prestacionales.valores[keys[0]];
            }
          }

          this.prestacionales.cargando = false;
        });
      else this.prestacionales.cargando = false;
    },
    guardar() {
      this.guardando = true;

      let prestaciones = [];
      if (this.addPres) {
        Object.keys(this.prestacionales.valores).forEach((key) => {
          const pres = this.prestacionales.valores[key];

          pres.soluciones.forEach((sol) => {
            if (sol.copiarDe) {
              let buscada = null;
              pres.soluciones.forEach((solBuscar) => {
                if (solBuscar.codigoSol === sol.copiarDe) buscada = solBuscar;
              });

              if (buscada && buscada.modelo && Object.keys(buscada.modelo).length > 0)
                prestaciones.push({material: sol.codigoMaterial, prestacion: buscada.modelo});

            } else if (sol.modelo && Object.keys(sol.modelo).length > 0) {
              prestaciones.push({material: sol.codigoMaterial, prestacion: sol.modelo});
            }
          });
        });
      }

      let dataMat = {
        marca: this.form.marca,
        coleccion: this.form.coleccion,
        enlace: this.form.enlace,
        ceramicos: this.form.ceramico ? [this.form.ceramico.codigo] : [],
        noCeramicos: this.form.noCeramico ? [this.form.noCeramico.codigo] : [],
        usos: this.form.usos,
        formato: this.form.ancho + 'x' + this.form.largo,
        espesor: this.form.espesor,
        absorcionAgua: this.form.absorcionAgua,
        precio: this.form.precio,
        prestaciones: prestaciones,
        declaracionAmbiental: this.form.ambientales,
        imagenB64: this.form.imagenB64
      };

      if (this.esEdit) this.edit(this.materialEdit.id, dataMat);
      else this.add(dataMat);
    },
    add(data) {
      HttpHelper.post("material-personalizado/anyadir", data)
          .then(() => {
            this.reset();
            this.dialog = false;
            this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('mat_anyadido'), color: "success"});
            this.$emit("actualizado");
          })
          .catch(() => {

          })
          .finally(() => {
            this.guardando = false;
          });
    },
    edit(id, data) {
      HttpHelper.post(`material-personalizado/${id}/editar`, data)
          .then(() => {
            this.reset();
            this.dialog = false;
            this.$emit("actualizado");
          })
          .catch(() => {

          })
          .finally(() => {
            this.guardando = false;
          });
    },
    esValido() {
      if (this.form.marca == null || this.form.marca.length < 1) return false;
      if (this.form.coleccion == null || this.form.coleccion.length < 1) return false;
      if (this.form.usos.length < 1) return false;
      if (this.form.ancho == null || this.form.ancho === '') return false;
      if (this.form.largo == null || this.form.largo === '') return false;
      if (this.form.espesor == null || this.form.espesor === '') return false;
      if (this.form.enlace == null || this.form.enlace === '') return false;
      if (this.form.ceramico && this.form.absorcionAgua == null || this.form.absorcionAgua === [])
        return false;
      if (this.form.precio == null || this.form.precio.length < 1) return false;
      if (this.errorMateriales) return false;
      if (!this.esEdit && !this.form.imagenB64) return false;
      return this.form.ceramico != null || this.form.noCeramico != null;
    },
    cargarCeramicos() {
      HttpHelper.get("material-personalizado/materiales-ceramicos")
          .then((resp) => {
            this.ceramicos = resp;
          });
    },
    cargarNoCeramicos() {
      HttpHelper.get("material-personalizado/materiales-no-ceramicos")
          .then((resp) => {
            this.noCeramicos = resp;
          });
    },
    cargarUsos() {
      HttpHelper.get("material-personalizado/usos")
          .then((resp) => {
            this.usos = resp;
          });
    },
    cargarAbsorcionAgua() {
      HttpHelper.get("material-personalizado/absorcion-agua")
          .then((resp) => {
            this.absorcionAgua = resp;
          });
    },
    reset() {
      this.form.marca = null;
      this.form.coleccion = null;
      this.form.enlace = null;
      this.form.ceramico = null;
      this.form.noCeramico = null;
      this.form.usos = [];
      this.form.ancho = null;
      this.form.largo = null;
      this.form.espesor = null;
      this.form.absorcionAgua = null;
      this.form.precio = null;
      this.form.ambientales = {};
      this.form.imagenB64 = null;
      this.imagen = null;
      this.addDap = false;
      this.addPres = false;
    },
    cerrar() {
      this.dialog = false;
      this.addDap = false;
      this.addPres = false;
      this.$emit("cerrado");
    }
  },
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "descrip_empresa": "Información de la empresa",
    "descrip_material": "Tipo de material y usos previstos",
    "descrip_producto": "Descripción del producto",
    "descrip_personalizacion": "Personalización de las propiedades del material",
    "descrip_imagen": "Imagen producto",
    "descrip_imagen_larga": "Sube una imagen de tu producto para que aparezca como miniatura en el buscador de materiales publicados de la Biblioteca",
    "label_marca": "Marca:",
    "label_colec": "Colección - Pieza:",
    "label_enlace": "Enlace web:",
    "label_ancho": "Ancho (cm):",
    "label_largo": "Largo (cm):",
    "label_espesor": "Espesor (mm):",
    "ceramico": "Cerámico",
    "no_ceramico": "No cerámico",
    "btn_guardar": "guardar material",
    "dialog_titulo": "crear material personalizado",
    "tipo_obra": "tipo de obra del material",
    "selec_tipo_obra_primero": "Se debe de seleccionar antes el tipo de obra",
    "sol_cons": "tipo de solución constructiva del material",
    "selec_sol_cons_primero": "Se debe de seleccionar antes el tipo de solución constructiva",
    "selec_material": "Se debe de seleccionar antes el material",
    "material": "Material",
    "uso": "uso",
    "descripcion": "Al guardar un material personalizado se guardan el precio, declaración ambiental y declaración prestacional para que al crear un nuevo proyecto puedas seleccionar este material con su personalización",
    "label_cod": "Código",
    "label_ref": "Referencia",
    "label_precio": "Precio (€/m²)",
    "dap": "Declaración ambiental",
    "dpres": "características técnicas",
    "dialog_titulo_edit": "actualizar material personalizado",
    "descripcion_mat": "<span class='font-weight-bold'>Material:</span> {0} ({1})",
    "absorcion_agua": "Absorción de agua",
    "mat_anyadido": "El material ha sido añadido correctamente",
    "alert_prestacionales": "Debes seleccionar el material y el uso válidos antes",
    "cargando_prestacionales": "Cargando valores...",
    "tooltipForm": "Todos los campos excepto la declaración ambiental y características técnicas son obligatorios",
    "ver_rest_indi": "Ver resto de indicadores",
    "pers_amb_pers_descrip": "Personaliza los valores de impacto que desees, para los campos que no se rellenen se utilizarán en el cálculo los datos por defecto considerados por la herramienta.",
    "pers_cat_tecni_descrip": "Personaliza las características técnicas que desees haciendo clic en cada uno de los campos. Para los campos que no se rellenen se utilizarán en el cálculo los valores por defecto considerados por la herramienta."
  }
}
</i18n>
<!--@formatter:on-->